import { render, staticRenderFns } from "./StaffGroupList.vue?vue&type=template&id=2249b082&scoped=true&"
import script from "./StaffGroupList.vue?vue&type=script&lang=js&"
export * from "./StaffGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249b082",
  null
  
)

export default component.exports